import Vue from 'vue'
import VTooltip from 'v-tooltip'

const options = {
	defaultOffset: 4,
	disposeTimeout: 100,
}

Vue.use(VTooltip, options)
